module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/default_img-8bc3450b64ffcbf6b34b1bb6a4f5586b.jpg";